@if (!loading() && options().length === 0) {
  <span
    class="tw:text-muted-color tw:text-sm tw:px-2"
    test-id="ai-model-picker-empty">
    No LLM models configured
  </span>
} @else {
  <p-select
    [options]="options()"
    [ngModel]="selected()"
    (ngModelChange)="onSelect($event)"
    [loading]="loading()"
    placeholder="Select an LLM model"
    appendTo="body"
    scrollHeight="16rem"
    class="tw:rounded-full"
    panelStyleClass="ai-model-picker-panel-compact"
    test-id="ai-model-picker">
    <ng-template
      let-option
      pTemplate="selectedItem">
      <span class="tw:flex tw:items-center tw:gap-2">
        @if (providerLogo(option.provider)) {
          <i
            [ngClass]="providerLogo(option.provider)"
            class="tw:h-4 tw:w-4 tw:object-contain"></i>
        }
        <span>{{ option.displayName }}</span>
      </span>
    </ng-template>

    <ng-template
      let-option
      pTemplate="item">
      <span class="tw:flex tw:items-center tw:gap-2">
        @if (providerLogo(option.provider)) {
          <i
            [ngClass]="providerLogo(option.provider)"
            class="tw:h-4 tw:w-4 tw:object-contain"></i>
        }
        <span>{{ providerName(option.provider) }} · {{ option.displayName }}</span>
      </span>
    </ng-template>
  </p-select>
}
